<template>
    <div class="sidebar-footer">
        <i class="cui-moon icons font-2xl d-block mt-4"></i>
        <i class="cui-sun icons font-2xl d-block mt-4"></i>
        <span>Dark Theme</span>
        <c-switch v-on:change="clickedChangeColor" v-model="theme" class="mx-1" color="secondary" data-checked="Dark" label />
    </div>
</template>

<script>
import Vue from 'vue'
import { Switch as cSwitch } from "@coreui/vue";
import VueCookie from 'vue-cookie';

Vue.use(VueCookie);
Vue.$cookies.config('7d','','',true)

export default {
    name: "SidebarFooter",
    components: {
        cSwitch
    },
    data() {
        return {
            theme: true
        }
    },
    methods: {
        clickedChangeColor: function (state) {
            let timeExpire = new Date();
            timeExpire.setDate(timeExpire.getDate() + 30);
            let user = this.$cookie.get('userEmail') ? this.$cookie.get('userEmail') : this.$session.get('userEmail')
            if (state == true) {
                document.querySelector("body").classList.add("dark-theme");
                this.$cookie.set('theme-' + user, 'dark-theme', { expires: timeExpire.toGMTString(), path: '', domain: '', secure: true })
            } else {
                document.querySelector("body").classList.remove("dark-theme");
                this.$cookie.set('theme-' + user, 'light-theme', { expires: timeExpire.toGMTString(), path: '', domain: '', secure: true })
            }

        }
    },
    created() {
        let user = this.$cookie.get('userEmail') ? this.$cookie.get('userEmail') : this.$session.get('userEmail')
        if (this.$cookie.get('theme-' + user) == 'light-theme') {
            document.querySelector("body").classList.remove("dark-theme");
            this.theme = false;
        } else if (!this.$cookie.get('theme-' + user)) {
            document.querySelector("body").classList.remove("dark-theme");
            this.theme = false;
        }
    },
    mounted: function() {

    }
};
</script>

<style lang="scss">
.sidebar-footer {
    display: flex;
    i {
        margin: 4px 5px 0 0 !important;
        font-size: 17px !important;
    }
    > span {
        display: inline-block;
        vertical-align: top;
        margin-top: 2px;
    }
    .cui-moon {
        display: none !important;
    }
}

.dark-theme {
    .sidebar-footer {
        .cui-moon {
            display: inline-block !important;
        }
        .cui-sun {
            display: none !important;
        }
    }
}
</style>
